import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  toggle() {
    this.menuTarget.classList.toggle("open")
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-bars")
      this.iconTarget.classList.toggle("fa-times")
    }
  }
}
